<template>
  <VView class="contest-end" :header="$t('contestEnd.header')" back-button-to="/menu">
    <VText center>{{ $t('contestEnd.content') }}</VText>

    <VText center><small>Nie możesz znaleźć maila od nas? Sprawdź w SPAMie lub w zakładce Oferty na swoim koncie mailowym.</small></VText>
  </VView>
</template>

<script>
import VView from '@/components/VView.vue';
import VText from '@/components/VText.vue';

export default {
  name: 'ContestEnd',
  components: {
    VView,
    VText,
  },
};
</script>

<style lang="scss">
.contest-end {}
</style>
